import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Nav from "@/components/Nav";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Copy } from "lucide-react";
import FounderBadgeCard from "@/components/FounderBadgeCard";

export default function FounderProfile() {
  const { number } = useParams();
  const [f, setF] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/founders/${number}`).then((r) => setF(r.data)).catch(() => setNotFound(true));
  }, [number]);

  const copyLink = async () => {
    const url = `${window.location.origin}/founder/${number}`;
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Shareable link copied!");
    } catch {
      toast.error("Couldn't copy — long-press the link.");
    }
  };

  if (notFound) return (
    <div className="min-h-screen bg-[#FAFBFD]"><Nav />
      <div className="max-w-lg mx-auto p-12 text-center">
        <h1 className="text-2xl font-bold text-slate-900">Founder not found</h1>
        <p className="text-slate-500 mt-2">This founder number hasn't been claimed.</p>
        <Link to="/" className="mt-4 inline-block"><Button variant="outline" className="rounded-full">Back home</Button></Link>
      </div>
    </div>
  );

  if (!f) return <div className="min-h-screen bg-[#FAFBFD]"><Nav /><div className="p-12 text-center text-slate-500">Loading…</div></div>;

  return (
    <div className="min-h-screen bg-[#FAFBFD]">
      <Nav />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight text-center">
          Meet <span className="brand-gradient-text">Founder #{f.founding_number}</span>
        </h1>
        <p className="text-slate-600 mt-2 text-center">One of the first 100 to help others fight back against sneaky subscription charges.</p>

        <Card className="trust-card mt-8">
          <CardContent className="p-6 sm:p-8">
            <FounderBadgeCard founder={f} />
            <div className="mt-6 flex items-center gap-2 justify-center">
              <Button onClick={copyLink} variant="outline" className="rounded-full" data-testid="founder-copy-link-button">
                <Copy className="w-4 h-4 mr-2" /> Copy shareable link
              </Button>
            </div>
          </CardContent>
        </Card>

        <div className="text-center mt-8">
          <Link to="/"><Button variant="ghost" className="rounded-full">← Back to home</Button></Link>
        </div>
      </div>
    </div>
  );
}
